import React from 'react';
import './Features.css';

const Features = () => {
  const features = [
    {
      icon: '🎮',
      title: 'ألعاب عالية الجودة',
      description: 'نطور ألعاباً اجتماعية ممتعة تجذب اللاعبين وتبقيهم منخرطين لفترات طويلة'
    },
    {
      icon: '🤝',
      title: 'شراكات ذكية',
      description: 'نربط العلامات التجارية بجمهورها بطريقة طبيعية وغير مزعجة داخل تجربة اللعب'
    },
    {
      icon: '📊',
      title: 'تحليلات متقدمة',
      description: 'نوفر بيانات دقيقة عن تفاعل المستخدمين لمساعدة شركائنا على تحسين حملاتهم'
    },
    {
      icon: '🚀',
      title: 'نمو سريع',
      description: 'ألعابنا مصممة للانتشار الفيروسي عبر المشاركة الاجتماعية والمنافسة'
    }
  ];

  return (
    <section id="features" className="features">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">لماذا مصاقيل؟</h2>
          <p className="section-subtitle">نجمع بين الترفيه والتسويق بطريقة فريدة</p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon-large">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
